import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "var(--color-gray-600)",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M12 4a3.5 3.5 0 0 0-3.5 3.5 1 1 0 0 1-2 0 5.5 5.5 0 1 1 11 0 1 1 0 1 1-2 0A3.5 3.5 0 0 0 12 4",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M7.5 6.5a1 1 0 0 1 1 1 3.5 3.5 0 1 0 7 0 1 1 0 1 1 2 0 5.5 5.5 0 1 1-11 0 1 1 0 0 1 1-1M12 16c-2.839 0-5.37 1.37-6.986 3.509-.1.13-.175.231-.238.32q-.07.098-.103.152c.149.017.36.019.754.019H12a1 1 0 1 1 0 2H5.382c-.337 0-.673 0-.955-.034-.323-.038-.686-.131-1.019-.393a2 2 0 0 1-.546-.687 2 2 0 0 1-.219-.85 1.93 1.93 0 0 1 .267-1c.13-.233.312-.473.481-.697l.027-.036C5.391 15.692 8.498 14 12 14a1 1 0 1 1 0 2",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M11 15a1 1 0 0 1 1-1c3.501 0 6.609 1.692 8.582 4.303l.027.036c.17.224.351.465.481.697.158.28.274.605.267 1a2 2 0 0 1-.219.85c-.117.235-.296.491-.546.687-.333.262-.696.355-1.019.393a9 9 0 0 1-.955.034H12a1 1 0 1 1 0-2h6.573c.393 0 .605-.002.754-.019a3 3 0 0 0-.103-.153 16 16 0 0 0-.238-.32C17.37 17.37 14.84 16 12 16a1 1 0 0 1-1-1",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }